module.exports = __webpack_public_path__ + "static/media/melodiekao_CV.bb226d61.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/papers/melodiekao_CV.pdf
// module id = 144
// module chunks = 0